import { Component, Input, ViewEncapsulation, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { element } from 'protractor';

import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
//import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormGroupName} from '@angular/forms';
import { ValidationFormsService } from './validation-forms.service';
import { ValidatorFn, ValidationErrors } from '@angular/forms';
import { ToasterComponent, ToasterPosition } from '@coreui/angular';
import { AppToastComponent as ToastComp } from '../../../services/shared-service/toast-simple/toast.component'
import { HttpService } from '../../../services/http-service/http.service'
import { ModalDirective } from 'ngx-bootstrap/modal';

import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../../../services/storege-service/storage.service';
import * as moment from 'moment';
import { ValidationService } from '../../../services/validation-service/validation.service';
import { ToolService } from '../../../services/tool/tool.service';

@Component({
  //selector: 'app-toasters',
  templateUrl: 'basic-forms.component.html',
  styleUrls: ["../../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css",],
  //encapsulation: ViewEncapsulation.None,
  providers: [ ValidationFormsService ]
})


export class BasicFormsComponent {

  minDate = new Date(2017, 5, 10);
  maxDate = new Date(2022, 9, 15);
  bsValue: Date = new Date();

// Timepicker

  public isEnabled: boolean = true;

  public mfData? : object = {};
  public courts?;
  public users?;
  public memberships?;
  public timingSlots?;
  public daysArray?:Array<{nameEn: string}> = [];
  reoccurDays: string;
  isUpdate: boolean = false;
  dbFunction?: string;
  facilityMembershipUserId: string;
  membershipId: string;
  customerName: string;
  customerMobile: string;
  customerCountryCode: string;
  startDate: string;
  endDate: string;
  timeSlot: string;
  notes: string;
  ccy: string;
  totalPrice: string;
  totalPaid: string;
  status: string;
  public facilityId = '';
  public isLoading = false;
  addToAllFacilities: string;
  facilityCountryCode: string;

  public responseData?;
  public dbActiveData? = Array();

  isError: boolean = false;

  simpleForm: FormGroup;
  submitted = false;
  formErrors: any;

  //private toasterService: ToasterService;
  //public toasterconfig: ToasterConfig = new ToasterConfig({tapToDismiss: true, timeout: 5000});
  
  @ViewChild(ToastComp) toastComp: ToastComp;
  @ViewChild('dangerModal', {static: false}) public dangerModal: ModalDirective;

  public paddingStyle: Object = { 'padding-right': '20px'};


  constructor(
    private router: Router, 
    private http: HttpClient, 
    public route: ActivatedRoute,
    private fb: FormBuilder,
    public vf: ValidationFormsService, 
    public httpService: HttpService,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private storageSrv: StorageService,
    private validationSrv : ValidationService,
    public toolService: ToolService,
    ) {
    //if (localStorage.getItem('currentUser') === null) {this.router.navigateByUrl('/login');}
    if (localStorage.getItem('lang') === "ar") {
      //this.toasterconfig = new ToasterConfig({tapToDismiss: true, timeout: 5000, positionClass: 'toast-top-left'});
    }
    //this.toasterService = toasterService;
    this.formErrors = this.vf.errorMessages;
    this.facilityId = this.storageSrv.getFacilityId();
    this.facilityCountryCode = this.storageSrv.getFacilityCountryCode();
    //this.userId = this.storageSrv.getUser();

    if(this.router.getCurrentNavigation().extras.state?.createData == null)
    {
      this.isUpdate = true;
      this.mfData = this.router.getCurrentNavigation().extras.state?.data;
      this.facilityMembershipUserId = this.mfData['id'];
      this.facilityId = this.mfData['facilityIds'];
      this.membershipId = this.mfData['membershipId'];
      this.customerName = this.mfData['customerName'];
      this.customerMobile = this.mfData['customerMobile'];
      this.customerCountryCode = this.mfData['customerCountryCode'];
      this.startDate = this.mfData['startDate'] != null ? new Date(this.mfData['startDate'].replace(/-/g, "/")) : this.mfData['startDate'];
      this.endDate = this.mfData['endDate'] != null ? new Date(this.mfData['endDate'].replace(/-/g, "/")) : this.mfData['endDate'];
      this.notes = this.mfData['notes'];
      this.totalPrice = this.mfData['totalPrice'];
      this.totalPaid = this.mfData['totalPaid'];
      this.status = this.mfData['status'];
      this.addToAllFacilities = '0';
      this.updateMembershipList();
    }
    else
    {
      this.facilityMembershipUserId = '';
      this.membershipId = '';
      this.customerName = '';
      this.customerMobile = '';
      this.customerCountryCode = this.facilityCountryCode;
      this.startDate = '';
      this.endDate = '';
      this.notes = '';
      this.totalPrice = '';
      this.totalPaid = '';
      this.status = '';
      this.addToAllFacilities = '0';
    }
    //this.createForm();
  }

  ngOnInit(): void {
    this.validationSrv.validateAcess()
    .then(async () => {
      this.isLoading = true;
      this.route.queryParams.subscribe(async params => {
        await this.loadMembership(this.storageSrv.getFacilityId());
        await this.loadDays();
        await this.loadTimingSlots(this.facilityId);
        await this.createForm();
        await this.updateMembershipList();
      });
    })
    .finally();
  }

  isCollapsed: boolean = false;
  iconCollapse: string = 'icon-arrow-up';

  @Input() message : string;
  messages: string[] = [];
  updatedData = this.mfData;

  // Validators.pattern('^[0-9]{4}[\/][1-9]|1[012][\/][0-9]{2}$')]
  createForm() {
    this.simpleForm = this.fb.group({
      membershipId: [this.membershipId, [Validators.required]],
      customerName: [this.customerName, [Validators.required]],
      customerMobile: [this.customerMobile, [Validators.required]],
      customerCountryCode: [this.customerCountryCode, [Validators.required]],
      startDate: [this.startDate, [Validators.required]],
      endDate: [this.endDate, [Validators.required]],
      timeSlot: [this.timeSlot, [Validators.required]],
      notes: [this.notes, [Validators.required]],
      ccy: [this.ccy, [Validators.required]],
      totalPrice: [this.totalPrice, [Validators.required]],
      totalPaid: [this.totalPaid, [Validators.required]],
      status: [this.status],
      addToAllFacilities: [this.addToAllFacilities],
    }, { });
  }
  get f() { return this.simpleForm.controls; }


  async showSuccess(msg) {

    await this.toastr.success(msg, 'Success');

    if (this.isUpdate && !this.isError)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });
      });  
    }
    else if (!this.isUpdate && this.isError == false)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });
      });  
    }
  }

  showError(msg) {
    //this.toasterService.pop('error', 'Error', msg);
  }

  public showPayment()
  {
    //this.router.navigate(['facility'], {state: {data: ''}, relativeTo: this.route});
    // if (this.editFlag == true)
    // {
    //   this.editFlag = false;
    // }
    // if (this.editFlag == false)
    // {
    //   this.editFlag = true;
    // }
    // this.myDivRef.nativeElement.scrollIntoView({behavior: "smooth", block: "start" });
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.simpleForm.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
}


saveMembership = () => {
  return new Promise<any>(async (resolve, reject) => {
    this.isLoading = true;
    let formattedStartDate = (moment(new Date(this.f['startDate'].value))).format('YYYY-MM-DD');
    let formattedEndDate = (moment(new Date(this.f['endDate'].value))).format('YYYY-MM-DD');

    const fields = {
      facilityMembershipUserId: this.facilityMembershipUserId,
      facilityId: this.facilityId,
      membershipId: this.f['membershipId'].value,
      customerName: this.f['customerName'].value,
      customerMobile: this.f['customerMobile'].value,
      customerCountryCode: this.f['customerCountryCode'].value,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      totalPrice: this.f['totalPrice'].value,
      totalPaid: this.f['totalPaid'].value,
      notes: this.f['notes'].value,
      status: this.f['status'].value,
      addToAllFacilities: this.f['addToAllFacilities'].value,
    };
    if (this.isUpdate) 
    {
      this.localInterfaceSrv.updateMembership(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('Membership Updated');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.warning(err.desc, "Error");
      })
      .finally(() => this.isLoading = false);
    } 
    else 
    {
      this.localInterfaceSrv.addMembership(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('Membership Added');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.warning(err.desc, "Error");
      })
      .finally(() => this.isLoading = false);
    }
  });
}

  async delay(ms: number) {
    //await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>this.toolService.showConsoleLog("fired"));
}

  collapsed(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  updateData(name: string): void {
    this.updateData['nameEn'] = name;
  }
 

  expanded(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.iconCollapse = this.isCollapsed ? 'icon-arrow-down' : 'icon-arrow-up';
  }
  updateMembershipPrice() {
    var selectedMembership = this.f['membershipId'].value;
    this.memberships.forEach(membership => {
      if (membership.id == selectedMembership)
      {
        this.simpleForm.patchValue({totalPrice: membership.price});
      }
    });

  }
  loadDays = () => {
      this.daysArray.push({
        nameEn: 'saturday'
      },
      {
        nameEn: 'sunday'
      },
      {
        nameEn: 'monday'
      },
      {
        nameEn: 'tuesday'
      },
      {
        nameEn: 'wednesday'
      },
      {
        nameEn: 'thursday'
      },
      {
        nameEn: 'friday'
      });
  }
  loadTimingSlots = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getTimingSlots(facilityId)
      .then(res => {
        this.timingSlots = res.content;
        if (this.timingSlots == ''){
          var defaultSlots:Array<{nameEn: string, timingInMinutes: number}> = [];
          defaultSlots.push({
            nameEn: '30 Minutes',
            timingInMinutes: 30
          });
          defaultSlots.push({
            nameEn: '1 Hour',
            timingInMinutes: 60
          });
          defaultSlots.push({
            nameEn: '1 Hour 30 Minutes',
            timingInMinutes: 90
          });
          defaultSlots.push({
            nameEn: '2 Hours',
            timingInMinutes: 120
          });
          defaultSlots.push({
            nameEn: '2 Hours 30 Minutes',
            timingInMinutes: 150
          });
          defaultSlots.push({
            nameEn: '3 Hours',
            timingInMinutes: 180
          });
          defaultSlots.push({
            nameEn: '3 Hours 30 Minutes',
            timingInMinutes: 210
          });
          defaultSlots.push({
            nameEn: '4 Hours',
            timingInMinutes: 240
          });
          defaultSlots.push({
            nameEn: '4 Hours 30 Minutes',
            timingInMinutes: 270
          });
          defaultSlots.push({
            nameEn: '5 Hours',
            timingInMinutes: 300
          });
          defaultSlots.push({
            nameEn: '5 Hours 30 Minutes',
            timingInMinutes: 330
          });
          defaultSlots.push({
            nameEn: '6 Hours',
            timingInMinutes: 360
          });
          this.timingSlots = defaultSlots;
        }
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.description, "Error");
      })
      .finally(() => this.isLoading = false
      );
    });
  }
  public roundTo = function(num: number, places: number) {
    const factor = 10 ** places;
    return Math.round(num * factor) / factor;
  };

  deleteMembership = (facilityMembershipUserId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const fields = {
        facilityMembershipUserId: facilityMembershipUserId
      };
      this.localInterfaceSrv.deleteMembership(facilityMembershipUserId)
      .then(async res => {
        resolve(res);
        this.toastr.success("Membership Removed", "Success");
        this.dangerModal.hide();
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
        });
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.desc, "Error");
        this.dangerModal.hide();
      })
      .finally(() => this.isLoading = false);
    });
  }
  loadMembership = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getMembershipList(facilityId)
      .then(res => {
        this.memberships = res.content;
        this.isLoading = false;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
      })
      .finally();
    });
  }

  async updateMembershipList()
  {
    if (this.isUpdate)
    {
      this.f['customerCountryCode'].disable();
      this.f['customerMobile'].disable();
      this.f['totalPrice'].disable();
    }
    else
    {
      this.f['customerCountryCode'].enable();
      this.f['customerMobile'].enable();
    }
  }
}